export const containers: TableModule = {
    name: "containers",
    route: "spa.projects.organisations.projects.containers",
    routeParams: [
        {
            param: "organisation",
            prop: "organisation_id",
        },
        {
            param: "project",
            prop: "project_id",
        },
    ],
    columns: [
        {
            name: "image_id",
            mobile: true,
            width: "w-[150px]"
        },
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true
        },
        {
            name: "article_number",
            sortable: true,
            mobile: true
        },
        {
            name: "waste_id",
            sortable: true
        },
        {
            name: "count",
            sortable: true,
        },
    ],
    filters: [
        {
            name: "id",
            column: "containers.id",
            type: "numeric"
        }
    ],
    quickFilters: [],
    tools: [
        {
            name: "containers.create",
            isCreateAction: true,
            ability: ["create", "containers"],
        },
    ]
}